/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from "react";
import { address, name, corporate } from "../../util/DataObject"

const ListDetail = (props) => {
  return (
    <div data-testid="listsDetail" className="dataBlock blackList">
      {props.detail.type === "name" &&
        name.map((i) => {         
          return (
            <div key={`name-${i.value}`} className="dataBlockItem">
              <label className="neutral report_display">{i.label}</label>
              <p>{props.detail.value[i.value] && i.value === "bdate" ? props.detail.value[i.value].substr(0, 10).split("-").reverse().join('-') : 
                  props.detail.value[i.value] ? props.detail.value[i.value][0].toUpperCase() + props.detail.value[i.value].substring(1).toLowerCase() : "N/A"}</p>
            </div>
          );
        })}

      {props.detail.type === "address" &&
        address.map((i) => {
          switch (i.value) {
            case "country":
              return props.countries.map((c) => {
                return (
                  c["k"] == props.detail.value[i.value] && (
                    <div key={`country-${c["v"]}`} className="dataBlockItem">
                      <label className="neutral report_display">
                        {i.label}
                      </label>
                      <p>{c["v"]}</p>
                    </div>
                  )
                );
              });
            case "state":
              return props.states.map((c) => {
                if (c["k"] == props.detail.value[i.value]) {                 
                  return (
                    <div key={`state-${c["v"]}`} className="dataBlockItem">
                      <label className="neutral report_display">
                        {i.label}
                      </label>
                      <p>{c["v"]}</p>
                    </div>
                  );
                }
              });
            default:
              return (
                <div key={`address-${i.value}`} className="dataBlockItem">
                  <label className="neutral report_display">{i.label}</label>
                  <p>{props.detail.value[i.value] ?  props.detail.value[i.value][0].toUpperCase() + props.detail.value[i.value].substring(1).toLowerCase() : "N/A"}</p>
                </div>
              );
          }
        })}

      {props.detail.type === "business_name" &&
        corporate.map((i) => {         
          return (
            <div key={`corporate-${i.value}`} className="dataBlockItem">
              <label className="neutral report_display">{i.label}</label>
              <p>{props.detail.value[i.value] && i.value === "bdate" ? props.detail.value[i.value].substr(0, 10).split("-").reverse().join('-') : 
                  props.detail.value[i.value] ? props.detail.value[i.value][0].toUpperCase() + props.detail.value[i.value].substring(1).toLowerCase() : "N/A"}</p>
            </div>
          );
        })}
      {props.detail.type !== "address" && props.detail.type !== "name" && props.detail.type !== "business_name" && (
        <div key={`type`} className="dataBlockItem">
          <label className="neutral report_display">Dato de alta</label>
          <p>{props.detail.value}</p>
        </div>
      )}
      {props.detail.reason && (
        <div key={`reason`} className="dataBlockItem">
          <label className="neutral report_display">Motivo</label>
          <p>{props.detail.reason}</p>
        </div>
      )}
      {props.detail.details && (
        <div key={`details`} className="dataBlockItem">
          <label className="neutral report_display">Detalle</label>
          <p>{props.detail.details}</p>
        </div>
      )}
      {props.detail.customer_uuid && (
        <div key={`customer_uuid`} className="dataBlockItem">
          <label className="neutral report_display">Cliente UUID</label>
          <p>{props.detail.customer_uuid}</p>
        </div>
      )}
    </div>
  );
};

export default ListDetail;
